/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Drawer_EmptyInputs */

const en_drawer_empty = /** @type {(inputs: Drawer_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No plans yet. Start with an idea.`)
};

const id_drawer_empty = /** @type {(inputs: Drawer_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belum ada rencana. Mulai dari ide.`)
};

/**
* | output |
* | --- |
* | "No plans yet. Start with an idea." |
*
* @param {Drawer_EmptyInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const drawer_empty = /** @type {((inputs?: Drawer_EmptyInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Drawer_EmptyInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_drawer_empty(inputs)
	return en_drawer_empty(inputs)
});